<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 10:47:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-08 15:50:55
--> 
<template>
  <div class="box">
    <v-icon class="material-icons icons">
      cloud_upload
    </v-icon>
    <span class="span2">
      <v-btn rounded
             color="#fff2d1"
             class="btn"
             dark>Browse</v-btn>
    </span>
    <span class="span3">
      *支持 .xls / .xlsx / .cvs
    </span>
    <span class="span4">
      *{{label_pleaseUseTempleteUploadData}}, <span class="span5">{{$t('label_Download_the_template')}}</span>
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {

    };
  },
  computed: {},
  created () { },
  watch: {},
  mounted () { },

  methods: {

  },
};
</script>

<style scoped>
.icons {
  color: #e0e0e0;
  font-size: 55px;
  padding: 0 140px;
  margin-top: 5px;
}
.box {
  background-color: #ffffff;
  border: 4px dashed #e0e0e0;
  width: 100%;
  height: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 350px;
}
.span3 {
  color: #a4a4a4;
  margin-top: 18px;
}
.span4 {
  color: #a4a4a4;
}
.span5 {
  color: #ffbe68;
  text-decoration: underline;
}
.btn {
  color: #ffbe68;
  height: 41px;
}
</style>
